import {httpGet, httpPost, httpPut} from "./http";
import {getActiveUser} from "../lib/activeMember";

const usersUrl = window.env.BACKEND_API_URL + "/users";

const createUser = ({email, password}, signal) => {
    const body = {
        email,
        password,
    };

    return httpPost(usersUrl, body, signal);
};

const getUser = (id, signal) => {
    const userGetUrl = `${usersUrl}/${id}`;
    return httpGet(userGetUrl, signal);
};

const updateUser = ({email}, signal) => {
    const userID = getActiveUser().id;

    const updateUrl = `${usersUrl}/${userID}`;
    const body = {
        email,
    };

    return httpPut(updateUrl, body, signal);
};

const sendLoginEmailVerification = (isStaff, signal) => {
    const id = getActiveUser().id;

    const resendUrl = `${usersUrl}/resend_verification_email`;
    const body = {
        'id': id,
        'is_staff': isStaff
    };

    return httpPost(resendUrl, body, signal);
};

export {createUser, getUser, updateUser, sendLoginEmailVerification};
